/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/*
 * Author M. Atoar Rahman
 * Title: Current Stock By Date
 * Description: Index for Current Stock By Date
 */

import { useEffect, useRef } from 'react';
import { Card } from 'react-bootstrap';
import Loader from '../../Loader';
import { useCurrentStockByDate } from './ContextAPI';
import CurrentData from './CurrentData';
import FormInfo from './FormInfo';
import PrintIndex from './pdf/PrintIndex';

export default function Index() {
    const { loading, showPdf, data } = useCurrentStockByDate();
    const resultRef = useRef();

    useEffect(() => {
        if (!loading && data) {
            resultRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [loading, data]);

    return (
        <>
            <FormInfo />
            {loading && (
                <Card className="mt-3">
                    <Card.Body className="text-center py-5">
                        <Loader />
                    </Card.Body>
                </Card>
            )}
            {!loading && data && showPdf && (
                <div ref={resultRef} style={{ scrollMarginTop: '80px' }}>
                    <PrintIndex />
                </div>
            )}
            {!loading && data && !showPdf && (
                <div ref={resultRef} style={{ scrollMarginTop: '80px' }}>
                    <CurrentData />
                </div>
            )}
        </>
    );
}
